import { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import { MdError } from "react-icons/md";

import { Loader } from "../../components/Loader";
import RestaurantInvoice from "../../components/restaurant/invoice";
import { useQuery } from "react-query";

const UserOrder = () => {
  const { id } = useParams<{ id: string }>();

  const {
    data: invoice,
    isLoading,
    isError,
    error,
  } = useQuery(
    "Get Invoice",
    async () => {
      const response = await axios.get("/order/user", {
        params: {
          orderId: id,
        },
      });
      return response.data.order;
    },
    { retry: 1, refetchOnWindowFocus: false }
  );

  useEffect(() => {
    document.title = "Specter | Invoice";
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center items-center py-40">
        <Loader />
      </div>
    );

  if (isError || !invoice) {
    return (
      <div
        dir="ltr"
        className="w-full min-h-screen flex justify-center md:items-center p-4 md:p-0 overflow-auto"
      >
        <div className="flex flex-col justify-center items-center w-full md:!w-96  h-fit p-6 rounded-2xl md:bg-gray-100 md:shadow-xl shadow-black my-4 md:my-10">
          <div className="flex flex-col justify-center items-center rounded-lg p-6 shadow shadow-red-500 bg-red-100 text-red-500 gap-4 my-10">
            <MdError className="text-5xl" />
            <p className="text-xl font-bold">Oops!</p>
            <p className="font-semibold">
              {typeof error === "object" &&
              error !== null &&
              "response" in error &&
              (error as any).response?.data?.message
                ? (error as any).response.data.message + "."
                : "An error occurred"}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      dir="ltr"
      className="w-full min-h-screen flex justify-center items-start p-4 md:p-0 overflow-auto"
    >
      <RestaurantInvoice invoice={invoice} type="user" />
    </div>
  );
};

export default UserOrder;
